import { useMemo } from "react";

const useIsLaptop = () => {
  const isLaptop = useMemo(() => window.outerWidth < 1400, [window.outerWidth]);
  return isLaptop;
};
export default useIsLaptop;
